module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDUwIDE0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojZmY3Njg5O2ZvbnQtc2l6ZToxNHB4O2ZvbnQtZmFtaWx5OkhlbHZldGljYS1Cb2xkLCBIZWx2ZXRpY2E7Zm9udC13ZWlnaHQ6NzAwO2xldHRlci1zcGFjaW5nOjAuMDVlbTt9PC9zdHlsZT48L2RlZnM+PHRleHQgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMTEpIj48dHNwYW4geD0iMCIgeT0iMCI+RU5UUlk8L3RzcGFuPjwvdGV4dD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/entry.svg
// module id = poiQ
// module chunks = 0